import { render, staticRenderFns } from "./datalive1.vue?vue&type=template&id=89940f2e&scoped=true&"
import script from "./datalive1.vue?vue&type=script&lang=js&"
export * from "./datalive1.vue?vue&type=script&lang=js&"
import style0 from "./datalive1.vue?vue&type=style&index=0&id=89940f2e&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89940f2e",
  null
  
)

export default component.exports